import { InstructionFormDetails } from '@supplierRegistration/routes/commonAfterFormPage/InstructionFormDetails';
import React from 'react';
import { NormalText } from '../../../Styles';
import FrictionlessAfterFormSpecialComponent from '../FrictionlessAfterFormSpecialComponent';
import config from '@app/config';

export const MexicoFrictionlessFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.mexicoFrictionless.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America,
        <br />
        222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.mexicoFrictionless.pleaseNote',
      'supplierValidation.afterRegister.mexicoFrictionless.troubleLocatingInfo',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: null,
  specialComponent: (
    <FrictionlessAfterFormSpecialComponent
      step1={'supplierValidation.afterRegister.mexicoFrictionless.noticeItem1'}
      step2={'supplierValidation.afterRegister.mexicoFrictionless.noticeItem2'}
      withFieldInstructions={true}
    />
  ),
  downloadLink: `${config.supplierValidationAttachmentsUrl}MexicoFrictionless/en/mexico-lf.pdf`,
};
